import React from "react";

const CourseCardMock = () => {
  return (
    <div
      style={{ width: 255, height: 400, textDecoration: "none" }}
      className="text-brand-link-gray bg-white flex flex-col rounded-brand shadow-sm border border-gray-300 hover:shadow mock"
    >
      <div className="relative">
        <div
          className="bg-gray-300"
          style={{
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
            width: 255,
            height: 155,
          }}
        />
      </div>
      <div className="p-4 flex flex-col h-full">
        {/* { Aca va la barra de detalles} */}
        <div className="flex justify-between text-sm">
          <span>
            <div className="bg-gray-300 w-10 h-5" />
          </span>
          <span>
            <div className="bg-gray-300 w-10 h-5" />
          </span>
          <span>
            <div className="bg-gray-300 w-10 h-5" />
          </span>
        </div>
        {/* { Aca va el titulo del curso} */}
        <div className="text-left font-medium text-base mt-3 leading-snug text-gray-800 flex-1">
          <div className="bg-gray-300 w-full h-5 mb-1" />
          <div className="bg-gray-300 w-full h-5" />
        </div>
        {/* { Aca va datos del autor} */}
        <div className="flex items-center mt-2 text-left">
          <div
            className="rounded-full mr-3 bg-gray-300"
            style={{ height: 36, width: 36 }}
          />
          <span className="bg-gray-300 h-5 w-20" />
        </div>
        {/* { Aca va rating del curso} */}
        <div className="mt-3 flex items-end justify-between">
          <div className="bg-gray-300 w-32 h-5" />
          <div className="bg-gray-300 w-12 h-5" />
        </div>
        <hr className="mt-2 mb-3" />
        {/* { Aca va call to action} */}
        <div className="text-base flex justify-between items-center">
          <div
            className="btn bg-gray-300 flex-1 px-1 leading-tight"
            style={{ width: "100%", height: 36, marginRight: 15 }}
          />
          <div
            style={{ width: 46, height: 36, padding: 0 }}
            className="bg-gray-300 btn"
          />
        </div>
      </div>
    </div>
  );
};

export default CourseCardMock;
